/**
 * Códigos de erro da leitura do cronograma por item (Fase 25).
 *
 * São erros **do arquivo inteiro** — cabeçalho que não existe, coluna que falta. O que está
 * errado em uma linha só não derruba a leitura: vira `issue`, com o número da linha do Excel,
 * e a conferência mostra ao lado das linhas boas.
 */
export const GANTTPRO_ERROR = {
  /** Nenhuma linha tem "Número de EDT" e "Nome da tarefa" juntos. */
  HEADER_NOT_FOUND: 'SCHEDULE_ITEMS.GANTTPRO_HEADER_NOT_FOUND',
  /** O cabeçalho existe, mas falta uma coluna sem a qual não há tarefa. */
  MISSING_COLUMNS: 'SCHEDULE_ITEMS.GANTTPRO_MISSING_COLUMNS',
  /** Nenhuma linha do arquivo é uma tarefa. */
  NO_TASKS: 'SCHEDULE_ITEMS.GANTTPRO_NO_TASKS',
  /** A aba não tem o cabeçalho do modelo "cronograma por item". */
  TEMPLATE_HEADER_NOT_FOUND: 'SCHEDULE_ITEMS.TEMPLATE_HEADER_NOT_FOUND',
  /** O modelo existe, mas falta coluna obrigatória. */
  TEMPLATE_MISSING_COLUMNS: 'SCHEDULE_ITEMS.TEMPLATE_MISSING_COLUMNS',
  /** O modelo não traz nenhuma linha de item. */
  TEMPLATE_NO_ROWS: 'SCHEDULE_ITEMS.TEMPLATE_NO_ROWS',
} as const;

/** Problema de uma linha — o arquivo continua sendo lido. */
export interface RowIssue {
  /** Linha do Excel (a primeira é 1), como o usuário a vê no arquivo. */
  readonly rowNumber: number;
  readonly message: string;
}
